import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '.././Design.css';
import './Home.css';
import Modal from '../components/Modal';

function Home() {
  const navigate = useNavigate();

  const [instances, setInstances] = useState([]);
  const [available, setAvailable] = useState([]);
  const [showRoomModal, setShowRoomModal] = useState(false);
  const [currRoom, setCurrRoom] = useState(null);

  // Fetch all ongoing game instances
  const fetchInstances = () => {
    fetch('/api/player/instances', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('No ongoing game instances found');
        }
        return response.json();
      })
      .then((data) => {
        setInstances(data.data.ongoing_instances);
      })
      .catch(error => console.error('Error during fetch instances: ', error));
  };

  // Fetch only roles that are still available (not yet taken)
  const fetchAvailable = (instance_id) => {
    fetch(`/api/player/instance/${instance_id}/roles/check`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Instance not found');
        }
        return response.json();
      })
      .then((data) => {
        // `data.data.available_roles` is the array of RoleDTO objects
        setAvailable(data.data.available_roles);
      })
      .catch(error => console.error('Error during fetch available roles: ', error));
  };

  // When a room is clicked, load the available roles for that instance
  const handleRoomClick = (instance_id) => {
    setCurrRoom(instance_id);
    fetchAvailable(instance_id);
    setShowRoomModal(true);
  };

  const closeRoomModal = () => {
    setCurrRoom(null);
    setShowRoomModal(false);
  };

  // Select a role (POST to backend)
  const selectRole = (instance_id, role_id) => {
    fetch(`/api/player/instance/${instance_id}/role/${role_id}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    })
      .then((response) =>
        response.json().then(data => ({ status: response.status, data }))
      )
      .then(({ status, data }) => {
        if (status === 200) {
          alert(data.message);
          navigate('/studentinfo', { state: { instance: instance_id, role: role_id } });
        } else {
          alert(data.message || 'Could not select role');
        }
      })
      .catch(error => console.error('Error during select role: ', error));
  };

  useEffect(() => {
    fetchInstances();
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '0 10px' }}>
      <h1 style={{ marginTop: '30px' }}>Welcome to the ELC!</h1>

      {instances.length === 0 ? (
        <div style={{ textAlign: 'center' }}>
          <h2>No Ongoing Games...</h2>
          <h2>Refresh the Page or Check Back Later</h2>
        </div>
      ) : (
        <div style={{ width: '80%', textAlign: 'center' }}>
          <h2>Please select the room you are in to join</h2>
          <div className="rooms-container">
            {instances.map((instance, idx) => (
              <div
                className="room"
                key={idx}
                onClick={() => handleRoomClick(instance.instance_id)}
              >
                <h2>
                  {instance.location_name} Room {instance.room_name}
                </h2>
                <div className="room-info">
                  Location: {instance.location_name}<br />
                  Status: {instance.state}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <Modal isOpen={showRoomModal} onClose={closeRoomModal}>
        <h1>Select Your Role</h1>
        {available.length === 0 ? (
          <p>No roles available in this room.</p>
        ) : (
          available.map((role, idx) => (
            <div
              className="role"
              key={idx}
              onClick={() => selectRole(currRoom, role.id)}
            >
              <h2>{role.name}</h2>
            </div>
          ))
        )}
      </Modal>
    </div>
  );
}

export default Home;
